import {
    UPDATE_CALENDAR_SETTINGS,
    UPDATE_CALENDAR_SETTINGS_SUCCESS,

    UPDATE_CALENDAR_REGISTRATION_SETTINGS,
    UPDATE_CALENDAR_REGISTRATION_SETTINGS_SUCCESS,

    GET_CALENDAR_APPEARANCE_LIST,
    GET_CALENDAR_APPEARANCE_LIST_SUCCESS,

    SHOW_PUBLISH,
    SHOW_PUBLISH_SUCCESS,

    GET_CALENDAR_SETTINGS,

    GET_CALENDAR_SETTINGS_SUCCESS
} from './constants';

/**
 *
 * @param id
 * @param value
 * @returns {{id: *, type: string, value: *}}
 */
const updateCalendarSettings = ( id, value ) => ( {
    type: UPDATE_CALENDAR_SETTINGS,
    id,
    value
} );
/**
 *
 * @param settings
 * @returns {{settings: *, type: string}}
 */
const updateCalendarSettingsSuccess = settings => ( {
    type: UPDATE_CALENDAR_SETTINGS_SUCCESS,
    settings
} );
/**
 *
 * @param settingsID
 * @param registrationSettings
 * @returns {{registrationSettings: *, settingsID: *, type: string}}
 */
const updateCalendarRegistrationSettings = ( settingsID, registrationSettings ) => ( {
    type: UPDATE_CALENDAR_REGISTRATION_SETTINGS,
    settingsID,
    registrationSettings
} );
/**
 *
 * @param calendar
 * @returns {{calendar: *, type: string}}
 */
const updateCalendarRegistrationSettingsSuccess = ( calendar ) => ( {
    type: UPDATE_CALENDAR_REGISTRATION_SETTINGS_SUCCESS,
    calendar
} );
/**
 *
 * @param calendarID
 * @returns {{calendarID: *, type: string}}
 */
const getCalendarAppearancesList = calendarID => ( {
    type: GET_CALENDAR_APPEARANCE_LIST,
    calendarID
} );
/**
 *
 * @param appearances
 * @returns {{appearances: *, type: string}}
 */
const getCalendarAppearancesListSuccess = appearances => ( {
    type: GET_CALENDAR_APPEARANCE_LIST_SUCCESS,
    appearances
} );
/**
 *
 * @param value
 * @returns {{type: string, value: *}}
 */
const showPublish = value => ( {
    type: SHOW_PUBLISH,
    value
} );
/**
 *
 * @param value
 * @returns {{type: string, value: *}}
 */
const showPublishSuccess = value => ( {
    type: SHOW_PUBLISH_SUCCESS,
    value
} );

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const getCalendarSettings = id => ({
    type: GET_CALENDAR_SETTINGS,
    id
});

/**
 *
 * @param calendarSettings
 * @returns {{calendarSettings: *, type: string}}
 */
const getCalendarSettignsSuccess = calendarSettings => ({
    type: GET_CALENDAR_SETTINGS_SUCCESS,
    calendarSettings
});

export {
    updateCalendarSettings,
    updateCalendarSettingsSuccess,
    updateCalendarRegistrationSettings,
    updateCalendarRegistrationSettingsSuccess,
    getCalendarAppearancesList,
    getCalendarAppearancesListSuccess,
    showPublish,
    showPublishSuccess,
    getCalendarSettings,
    getCalendarSettignsSuccess
};